/**
 * Configuration utility that provides environment variables with fallback support.
 *
 * In production (with Octopus Deploy): Uses window.ENV (runtime substitution)
 * In local development: Falls back to process.env (Vite loads from .env.local)
 */

const getEnvVar = (key: string): string => {
  // Try window.ENV first (production with Octopus substitution)
  if (typeof window !== 'undefined' && window.ENV && window.ENV[key]) {
    const value = window.ENV[key];
    // Check if it's an Octopus placeholder (not yet substituted)
    if (value.startsWith('#{') && value.endsWith('}')) {
      // Placeholder not substituted, fall back to process.env
      return process.env[key] || '';
    }
    return value;
  }

  // Fallback to process.env (local dev with Vite)
  return process.env[key] || '';
};

export const config = {
  // Base URLs
  BASE_URL: getEnvVar('REACT_APP_BASE_URL'),
  ENVIRONMENT_URL: getEnvVar('REACT_APP_ENVIRONMENT_URL'),

  // Auth0
  AUTH_DOMAIN: getEnvVar('REACT_APP_AUTH_DOMAIN'),
  AUTH_CLIENT_ID: getEnvVar('REACT_APP_AUTH_CLIENT_ID'),
  AUTH_AUDIENCE: getEnvVar('REACT_APP_AUTH_AUDIENCE'),

  // Azure AD - fMoravia
  AZURE_DOMAIN: getEnvVar('REACT_APP_AZURE_DOMAIN'),
  AZURE_CLIENT_ID: getEnvVar('REACT_APP_AZURE_CLIENT_ID'),
  AZURE_AUDIENCE: getEnvVar('REACT_APP_AZURE_AUDIENCE'),

  // Azure AD - Highlander Worldwide
  WORLDWIDE_CLIENT_ID: getEnvVar('REACT_APP_WORLDWIDE_CLIENT_ID'),
  WORLDWIDE_DOMAIN: getEnvVar('REACT_APP_WORLDWIDE_DOMAIN'),

  // Azure - RWS One Entra ID
  RWSONE_CLIENT_ID: getEnvVar('REACT_APP_RWSONE_CLIENT_ID'),
  RWSONE_DOMAIN: getEnvVar('REACT_APP_RWSONE_DOMAIN'),

  // Helix
  HELIX_BASE_URL: getEnvVar('REACT_APP_HELIX_BASE_URL'),

  // API URL
  API_URL: getEnvVar('REACT_APP_API_URL'),

  // GLMS Linguist Management
  GLMS_STAGE: getEnvVar('REACT_APP_GLMS_STAGE'),
  BASE_GLMS_URL: getEnvVar('REACT_APP_BASE_GLMS_URL'),

  // Extensions
  EXT_STAGE: getEnvVar('REACT_APP_EXT_STAGE'),
  EXTENSIONS_API: getEnvVar('REACT_APP_EXTENSIONS_API'),

  // Adjustments
  GADJS_STAGE: getEnvVar('REACT_APP_GADJS_STAGE'),

  // Launch Darkly
  LD_ID: getEnvVar('REACT_APP_LD_ID'),

  // MAS service - auth
  MAS_URL: getEnvVar('REACT_APP_MAS_URL'),

  // WebSocket
  WS_PATH: getEnvVar('REACT_APP_WS_PATH'),

  // Services API
  SERVICES_API_URL: getEnvVar('REACT_APP_SERVICES_API_URL'),

  // Development flag (optional - for local dev override)
  IS_DEV: getEnvVar('REACT_APP_DEV') === 'true',

  // Invoice submission concurrency (optional - defaults to 1)
  INVOICE_SUBMISSION_CONCURRENCY: parseInt(getEnvVar('REACT_APP_INVOICE_SUBMISSION_CONCURRENCY')) || 1,
};
